import { render } from "./PhoneMockup.vue?vue&type=template&id=68669053&scoped=true"
import script from "./PhoneMockup.vue?vue&type=script&lang=js"
export * from "./PhoneMockup.vue?vue&type=script&lang=js"

import "./PhoneMockup.vue?vue&type=style&index=0&id=68669053&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68669053"]])

export default __exports__